window.createSwiper = function (target, watchOverflow = true) {
    new Swiper(`.${target}`, {
        slidesPerView: 1,
        spaceBetween: 30,
        breakpoints: {
            550: { slidesPerView: 1.8 },
            600: { slidesPerView: 2.3 },
            900: { slidesPerView: 3 },
            1100: { slidesPerView: 3.4 },
            1400: { slidesPerView: 5 },
        },
        navigation: {
            nextEl: `.swiper-button-next-${target}`,
            prevEl: `.swiper-button-prev-${target}`,
        },
        watchOverflow: watchOverflow,
    });
};
